import text from './text';
import image from './image';
import video from './video';
import button from './button';
import email_form from './email_form';
import coca_form from './coca_form';
import carousel from './carousel';
import tabs from './tabs';
import products_list from './products_list';
import form from './form';
import iframe from './iframe';
import i18n from './i18n';
import gql from "graphql-tag";
import wheel from './wheel';
import wheel2 from './wheel2';
import plan from './plan';
import quizz from './quizz';
import button_diffuse from './button_diffuse';
import agenda from './agenda';
import agendas2 from './agendas2';
import agenda_tableau from './agenda_tableau';
import products2 from './products2';
import photo from './photo';
import photobooth from './photobooth';
import modern_photobooth from './modern_photobooth';
import photobooth_gif from './photobooth_gif';
import photobooth_gif2 from './photobooth_gif2';
import photobooth_obs from './photobooth_obs';
import photobooth_landscape from './photobooth_landscape';
import photobooth_stripe_print from './photobooth_stripe_print';
import jackpot from './jackpot';
import cards_game from './cards_game';
import ranking from './ranking';
import photobooth_choice from './photobooth_choice';
import html from './html';
import send_email from './send_email';

export default {
  ranking,
  photo,
  photobooth,
  modern_photobooth,
  i18n,
  video,
  image,
  text,
  button,
  email_form,
  coca_form,
  carousel,
  tabs,
  products_list,
  form,
  wheel,
  wheel2,
  iframe,
  plan,
  quizz,
  button_diffuse,
  agenda,
  agendas2,
  agenda_tableau,
  products2,
  photobooth_gif,
  photobooth_gif2,
  photobooth_obs,
  photobooth_landscape,
  photobooth_stripe_print,
  jackpot,
  cards_game,
  html,
  photobooth_choice,
  send_email,
  create: gql`
    mutation CreateCell ($input: CreateCellInput!) {
      createCell (input: $input) {
        id
      }
    }
  `,

  listForPage: gql`
    query Cells($pageId: ID!) {
      cells(id: $id) {
        id
        project_id
        name
      }
    }
  `,

  updateCells: gql`
    mutation UpdateCells ($input: [UpdateCellInput]!) {
      updateCells (input: $input) {
        id
        links_to_page_id
        links_to_random_page_ids
        links_to_language
        is_back_link
      }
    }
  `,

  updateCellsCoordinates: gql`
    mutation UpdateCellsCoordinates ($input: [UpdateCellCoordinatesInput]!, $screenTypeId: ID!) {
      updateCellsCoordinates (input: $input, screenTypeId: $screenTypeId) {
        x
        y
        width
        height
      }
    }
  `,

  duplicateCell: gql`
    mutation DuplicateCell ($input: ID!) {
      duplicateCell (input: $input) {
        id
        cell_type
      }
    }
  `,

  deleteCell: gql`
    mutation DeleteCell ($input: ID!) {
      deleteCell (input: $input) {
        id
      }
    }
  `,
}
